var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrinkfluids(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 133.17 209.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #50a8de;\n      }\n\n      .cls-2 {\n        fill: #06334f;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2, .cls-3, .cls-6, .cls-9 {\n        stroke: #231f20;\n      }\n\n      .cls-2, .cls-4, .cls-9 {\n        stroke-width: 1.28px;\n      }\n\n      .cls-3 {\n        fill: #2e2423;\n        stroke-width: 1.59px;\n      }\n\n      .cls-4, .cls-7 {\n        stroke: #406f8c;\n      }\n\n      .cls-4, .cls-7, .cls-8, .cls-9 {\n        fill: none;\n      }\n\n      .cls-5, .cls-6, .cls-11, .cls-10 {\n        fill: #914b2c;\n      }\n\n      .cls-5, .cls-8 {\n        stroke-width: 2px;\n      }\n\n      .cls-5, .cls-8, .cls-10 {\n        stroke: #4a1c0d;\n      }\n\n      .cls-6 {\n        stroke-width: 1.65px;\n      }\n\n      .cls-12 {\n        fill: #75381c;\n      }\n\n      .cls-7 {\n        stroke-width: 1.45px;\n      }\n\n      .cls-13 {\n        fill: #d7e7f2;\n      }\n\n      .cls-10 {\n        stroke-width: 2.14px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M19.45,121.59c-4.3,7.78-7.71,15.44-12.01,23.22-1.88,3.4-3.9,6.36-4.75,10.16-.68,3.03-1.03,6.56-.98,9.67.12,7.45,0,15.17-.96,22.55-.34,2.67-.85,5.33-.72,8.02.25,5.05,2.91,9.93,7.02,12.88,2.06,1.47,4.94,2.45,7.05,1.05-.61-3.14-3.81-5-5.56-7.68-2.09-3.2-1.87-7.74.54-10.72,1.19.51,2.14,1.54,2.54,2.77.31.95.3,1.97.48,2.95s.61,2,1.49,2.47,2.23.03,2.36-.96c-.33-3.38-.71-6.93-2.62-9.74-.94-1.39-2.23-2.57-2.79-4.15-.45-1.28-.37-2.68-.24-4.03.6-6.23,2.1-12.36,4.45-18.16.84-2.06,1.09-4.19,1.56-6.37.5-2.34,1.73-4.36,2.48-6.62.53-1.59,2.23-3.93,3-5.42,2.75-5.33,4.65-8.51,7.61-13.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.85,117.43c-.86.68-1.65,1.46-2.32,2.34-3.53,4.64-3.14,11.07-2.58,16.87,1.11,11.48,4.24,36.24,5.35,47.72,0-.12-17.13,7.16-33.17,6.56-9.08-.34-18.43-3.1-27.38-4.65,1.02-15.55,3.01-44.57,3.65-58.88-2.2,1.89-4.18,4.02-5.92,6.34-3.67-5.02-9.01-9.78-15.18-12.79,4.72-5.41,10.18-10.12,15.77-14.64,2.38-1.92,4.8-3.83,7.53-5.2,3.08-1.54,6.47-2.36,9.87-2.95,7.02-1.21,14.2-1.48,21.28-.77,8.74-.15,17.45-1.58,25.77-4.25.69-.22,1.55-.41,2.06.11.18.18.27.42.37.66,2.47,6.23,4.68,12.56,6.64,18.97-2.74.31-5.42,1.07-7.92,2.23-1.35.63-2.66,1.39-3.82,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M61.1,106.3c.3,3.28-.75,5.98-1.38,9.14-.17.85-.2,1.75-.14,2.67-.36-3.99-.88-7.73-1.24-11.71-3.54-.51-6.38-3.45-6.62-7.17l-.87-13.01c-.28-4.28,2.96-7.98,7.24-8.27.17-.01.34-.02.52-.02,4.05,0,7.47,3.15,7.75,7.26l.86,13.01c.25,3.9-2.41,7.31-6.12,8.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 95.05,
    cy: 47.84,
    r: 8.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 56.17,
    cy: 44.59,
    rx: 40.21,
    ry: 43.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 14.7,
    cy: 57.72,
    r: 8.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M100.61,68.65c4.6,6.82,10.59,15.55,14.84,22.59-5.54.88-10.74,2.14-16.28,3.02,1.95,5.28,3.47,9.64,5.28,15.34.05-.6.11-1.47.2-1.51,2.79-1.04,5.49-1.43,8.37-2.21,6.89-1.88,11.42-3.61,17.12-6.65,1.07-.57,2.03-1.42,2.59-2.5,1.31-2.57-.51-5.56-2.25-7.85-6.13-8.08-12.27-16.16-18.4-24.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M43.79,13.76c-.36-.48-.7-.98-1.01-1.49.14-.01.29-.02.43-.03.23.49.42,1,.58,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M21.94,26.74c.91.57,1.74,1.24,2.48,2-.91-.57-1.74-1.24-2.48-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M24.42,28.74c-.91-.57-1.74-1.24-2.48-2,.91.57,1.74,1.24,2.48,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M21.94,26.74c.91.57,1.74,1.24,2.48,2-.91-.57-1.74-1.24-2.48-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M43.79,13.76c-.36-.48-.7-.98-1.01-1.49.14-.01.29-.02.43-.03.23.49.42,1,.58,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M36.49,46.21c5.03-3.08,11.21-4.22,17.01-3.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M66.2,43.22c4.26-3.22,10.04-4.33,15.19-2.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M57.86,49.43c.57,1.28.23,2.75.06,4.14s-.05,3.03,1.09,3.85c1.16.83,2.76.39,4.11-.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M72.82,66.94c-1.65-1.2-4.1-1.15-5.7.12-.7.56-1.23,1.3-1.75,2.03-.37.52-.74,1.04-1.11,1.56-.26.37-.51.93-.17,1.23.31.27.78.05,1.13-.16,1.1-.64,2.33-1.05,3.6-1.21,1.38-.18,3.06-.19,3.79-1.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "74.2 43.22 118.08 48.18 117.42 64.84 73.13 69.04 74.2 43.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M85.78,121.75c4.78-4.76,12.75-6.93,18.94-8.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.41,57.32c1.58-1.54,3.1-3.33,5.22-3.98,1.2-.37,2.5-.32,3.7-.67,1.53-.44,2.76-1.1,3.94-2.16.28-.25,6.86.1,9.59.43-.38,4.02-.3,6.71-.51,11.06-11.55.7-22.8,1.47-34.53,2.91-.73.09-1.47.03-2.21.07,2.37.27,5.71-1.54,7.76-2.6,2.58-1.33,4.96-3.04,7.04-5.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M90.11,41.62c-3.83,2.34-1.98,8.76,2.67,7.08,4.18-1.67,2.13-9.55-2.51-7.18l-.16.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M102.61,49.55c-4.93,2.49-7.79-4.95-3.4-7.35,5.43-2.56,8.55,4.4,3.58,7.26l-.18.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M107.23,46.06c-.16-5.19,6.69-5.6,8.05-1.01,1.5,6.92-7.38,8.27-8.04,1.21v-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M105.8,68c-1.15,1.81-3.09,3.11-5.2,3.49-1.29.24-2.7.12-3.77-.63-1.02-.72-1.57-2.1-.79-3.04.23-.27.79-.75,1.19-.87.99-.29,2.78-.96,2.46-2.52-.18-.87-.48-1.71-.74-2.57-.26-.89-.65-2.01-.06-2.71.79-.94,2.53-1.01,3.65-.51,1.51.67,3.42,2.14,4.12,4.81.4,1.54,0,3.21-.86,4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M12.49,57.55c1.13-1.05,2.7-1.62,4.25-1.55s3.05.79,4.08,1.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M37.39,127.41c1.58-1.66,4.28-4.55,6.15-5.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M115.45,91.24c1.76-.23,2.76-.15,4.45.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.94,33.82c-14-.02-25.61-10.01-27.76-23.09-5.06,7.3-13.62,12.1-23.33,12.1-5.84,0-11.24-1.73-15.72-4.67-.51,8.46-5.74,15.68-13.16,19.18,1.55-8.22,5.07-15.65,9.97-21.61.91-1.09,1.85-2.13,2.84-3.13C36.09,5.26,45.74.79,56.35.79c4.08,0,8.02.65,11.74,1.9,1.2.39,2.34.82,3.48,1.34,11.7,5.19,20.78,16.16,24.38,29.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M57.73,106.75c-1.73,2.89-4.9,8.76-5.8,12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M51.93,118.75c-4.71-4.86-7.17-13.59-5.56-20.17.75-.18,4.03-.74,4.8-.69.73,2.18.64,4.2,2.05,6.02.49.63,1.02,1.23,1.7,1.63,1,.59,2.05.84,3.23,1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M64.86,117.75c.03.12-2.1-8.01-3.94-10.92-.03-.05-.07-.11-.13-.11s-.1.1-.04.11c2.52.63,4.45-2.06,5.95-4.19.47-.66.77-1.51.94-2.3.27-1.27.06-2.38-.34-3.62,1.4.37,3.13.59,4.58.68,1.33,4.72.83,9.93-1.36,14.33-1.21,2.42-2.96,5.87-5.65,6.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M60.63,124.57c-.32-1.97-.9-4.21-1.04-6.33,0-.04-.01-.09-.01-.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M61.1,106.3c-.01-.1-.02-.21-.03-.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M59.58,118.11s.01.09.01.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M58.34,106.4c-.01-.14-.03-.29-.04-.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M61.07,105.98c.4,3.41-.7,6.2-1.35,9.46-.56,2.83.44,6.25.91,9.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M58.31,105.95c.37,4.2.92,8.09,1.29,12.29"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinkfluids);
export default __webpack_public_path__ + "static/media/drinkfluids.f90cc9254cd82edcf96335611f624b77.svg";
export { ForwardRef as ReactComponent };